import { moduleProviderFactory } from 'core/providers';
import { ImportList, ImportPatientList, ImportPatientCreate, ImportPatientEdit, ImportCreate, ImportPatientPreview, ImportPatientDuplicates } from 'application/import/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.patient-detail.edit',
                pattern: 'patient-detail/edit/:id',
                tabTitle:'Edit Patient Detail',
                component: ImportPatientCreate,
                data: {
                    title: 'FACILITY.EDIT.TITLE'
                },
            },
            {
                name: 'master.app.main.patient-detail.preview',
                pattern: 'patient-detail/preview/:id',
                tabTitle:'Preview Patient Detail',
                component: ImportPatientPreview
            },
            {
                name: 'master.app.main.import',
                pattern: '/imports',
                children: [
                    {
                        name: 'master.app.main.import.list',
                        pattern: '',
                        tabTitle:'Imports',
                        component: ImportList,
                        data: {
                            title: 'IMPORT.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.import.create',
                        pattern: '/create',
                        tabTitle:'Create Import',
                        component: ImportCreate,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'IMPORT.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.import.detail',
                        pattern: '/:id/patients',
                        children: [
                            {
                                name: 'master.app.main.import.detail.list',
                                pattern: '/',
                                tabTitle:'Patients Import',
                                component: ImportPatientList,
                                data: {
                                    title: 'IMPORT_PATIENT.LIST.TITLE',
                                    crumbs: {
                                        title: "IMPORT_PATIENT.LIST.TITLE",
                                        route: 'master.app.main.import.detail.list'
                                    }
                                }
                            },
                            // {
                            //     name: 'master.app.main.import.detail.create',
                            //     pattern: '/:importPatientId/create',
                            //     component: ImportPatientCreate,
                            //     data: {
                            //         title: 'IMPORT_PATIENT.CREATE.TITLE'
                            //     }
                            // },
                            {
                                name: 'master.app.main.import.detail.edit',
                                pattern: '/:importPatientId/edit',
                                tabTitle:'Edit Patient Import',
                                component: ImportPatientEdit,
                                data: {
                                    title: 'IMPORT_PATIENT.EDIT.TITLE'
                                }
                            },
                            {
                                name: 'master.app.main.import.detail.duplicate.list',
                                pattern: '/:firstName/:lastName/:importHeaderId/:patientGroupId',
                                tabTitle:'IMPORT.EXISTING_PATIENTS.TITLE',
                                component: ImportPatientDuplicates,
                                data: {
                                    title: 'IMPORT.EXISTING_PATIENTS.TITLE'
                                }
                            },
                        ]
                    }            
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.IMPORTS',
                route: 'master.app.main.import.list',
                icon:  'imports',
                order: 2
            }
        ]
    });
})();

